const BASE_URL = "https://api.corpernews.com/api/";

export default BASE_URL;
